// extracted by mini-css-extract-plugin
export default {"caseItem":"CaseStudiosItemBlock_caseItem__zG6r8","caseItemBtn":"CaseStudiosItemBlock_caseItemBtn__fTBBA"};